import { useEffect, useState, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'client/_redux/reducers';
import { getUserInvoices, sendInvoiceEmail } from 'dashboard/_redux/actions/invoices';

export const useInvoiceDetails = () => {
  const { userId } = useParams<{ userId: string }>();
  const dispatch = useDispatch();
  const [sendingId, setSendingId] = useState<string | null>(null);

  const {
    selectedUser: user,
    selectedUserInvoices: invoices,
    loaded,
  } = useSelector((state: RootState) => state.dashboardInvoices);

  useEffect(() => {
    if (userId) {
      dispatch(getUserInvoices(userId));
    }
  }, [dispatch, userId]);

  const handleSendInvoice = useCallback(
    async (invoiceId: string) => {
      setSendingId(invoiceId);
      await dispatch(sendInvoiceEmail(invoiceId));
      setSendingId(null);
    },
    [dispatch],
  );

  return { user, invoices, loaded, handleSendInvoice, sendingId };
};
